export default __webpack_public_path__ + "media/images/cadenas-ouvert-icone-4601-16-9ef6f63f573ef36ca9af157efdf8555e.png";